import { forwardRef } from 'react';
import { clsx } from 'clsx';
import { Box, type BoxProps } from '../Box/Box';
import { containerRecipe } from './container.css';

export type ContainerMaxWidth = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'none';

export type ContainerProps = Omit<BoxProps, 'maxWidth'> & {
  maxWidth?: ContainerMaxWidth;
};

export const Container = forwardRef<HTMLElement, ContainerProps>(
  ({ maxWidth = 'lg', className, ...props }, ref) => (
    <Box
      ref={ref}
      className={clsx(containerRecipe({ maxWidth }), className)}
      {...props}
    />
  ),
);
Container.displayName = 'Container';
